<template>
  <a-modal
    centered
    :visible="visible"
    :title="null"
    :footer="null"
    :width="418"
    :closable="false"
    :mask="false"
    wrap-class-name="add-tag-modal"
    @change="$emit('change', $event)"
    :afterClose="handleReset"
  >
    <div class="add-tag-container">
      <a-input v-model.trim="iptVal" class="search-ipt" @change="iptValChange" :placeholder="$t('home.EnteType')"></a-input>
      <a-button @click.native="addConfirm" :disabled="!iptVal">{{$t('common.Ok')}}</a-button>
    </div>
  </a-modal>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapActions } = createNamespacedHelpers('tag')

export default {
  name: 'AddTag',
  model: {
    prop: 'visible',
    event: 'change',
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      iptVal: '',
      preIptVal: '',
    }
  },
  methods: {
    ...mapActions(['addTag']),
    addConfirm() {
      this.addTag(this.iptVal)
        .then(_ => { this.$emit('change', false) })
        .catch(err => console.warn(err))
    },
    handleReset() {
      this.iptVal = this.preIptVal = ''
    },
    iptValChange(e) {
      const val = e.target.value.trim()
      let Chinese = ''
      const pattern = /[\u4e00-\u9fa5]/g
      val.replace(pattern, function (match){
        Chinese += match
      })
      if (Chinese.length * 2 + (val.length - Chinese.length) > 20) {
        this.$message.warn(this.$t('home.More20Char'))
        this.iptVal = this.preIptVal
        return
      }
      this.iptVal = this.preIptVal = val
    }
  }
}
</script>

<style scoped lang="less">
::v-deep .ant-modal-content {
  height: 104px;
  box-shadow: 0 10px 20px 0 rgba(62, 85, 132, 0.3);
  border-radius: 16px;
  .ant-modal-body {
    padding: 20px;
    .add-tag-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .search-ipt {
        width: 206px;
        height: 42px;
        background: #EFF3F8;
        box-shadow: 0 0 10px 0 rgba(151, 171, 199, 0.15);
        border-radius: 8px;
        border: none;
        &::placeholder {
          font-size: 16px;
          font-weight: 400;
          color: #6a6d73;
        }
      }
      button {
        width: 140px;
        height: 41px;
        background: linear-gradient(154deg, #236CFF 0%, rgba(35, 108, 255, 0.8) 100%);
        box-shadow: 0 5px 10px 0 rgba(35, 108, 255, 0.5);
        border-radius: 25px;
        color: #fff;
        border: none;
        font-size: 16px;
        font-weight: 600;
      }
    }
  }
}
</style>
